import {
  PlaceAutocomplete as SharedPlaceAutocomplete,
  type PlaceResult,
} from "@tabipla/components";
import { apiClient } from "../../infrastructure/api/client";

export type { PlaceResult };

interface PlaceAutocompleteProps {
  value: string;
  onChange: (place: PlaceResult | null) => void;
  placeholder?: string;
  disabled?: boolean;
}

export function PlaceAutocomplete(props: PlaceAutocompleteProps) {
  return <SharedPlaceAutocomplete {...props} apiClient={apiClient} />;
}
